var render, staticRenderFns
import script from "./CBottomSheet.vue?vue&type=script&lang=ts"
export * from "./CBottomSheet.vue?vue&type=script&lang=ts"
import style0 from "./CBottomSheet.vue?vue&type=style&index=0&id=18904ea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports